import {BasePlugin} from './BasePlugin';
import {CookieConsent} from '../CookieConsent';

export class PermissionDependantTemplateHandler extends BasePlugin {
    options = {
        templateSelector: '[data-consent-loading=""]',
        templateCategorySelector: '[data-consent-loading={0}]',
        templateTypeSelector: '[data-consent-type={0}]',
        clickableTemplateTypes: ['iframe', 'video'],
        pendingTemplateClass: '-pending-consent',
    };

    destroyController = new AbortController();

    constructor(options = {}) {
        super();

        this.options = {
            ...this.options,
            ...options,
        };
    }

    initialize(cookieConsent) {
        super.initialize(cookieConsent);

        this.dialog.addEventListener('consentLoaded', e => this.onConsentLoaded(e), {
            signal: this.destroyController.signal,
        });
        this.dialog.addEventListener('activateCategory', e => this.onActivateCategory(e), {
            signal: this.destroyController.signal,
        });

        this.setupClickableTemplates();
    }

    destroy() {
        this.destroyController.abort();
    }

    setupClickableTemplates() {
        const selector = this.options.clickableTemplateTypes
            .map(type => this.options.templateTypeSelector.replace('{0}', type))
            .join(',');

        const templates = document.querySelectorAll(selector);
        for (const template of templates) {
            template.classList.add(this.options.pendingTemplateClass);
            template.addEventListener('click', e => this.onTemplateClick(e), {
                signal: this.destroyController.signal,
            });
        }
    }

    onTemplateClick() {
        this.cookieConsent.show(CookieConsent.SOURCE_USER);
    }

    onConsentLoaded() {
        this.activatePermissionLessTemplates();
    }

    onActivateCategory(e) {
        this.activatePermissionLessTemplates();
        this.activateCategoryBasedTemplates([e.detail.category]);
    }

    activateCategoryBasedTemplates(categories) {
        for (const category of categories) {
            const templates = document.querySelectorAll(this.options.templateCategorySelector.replace('{0}', category));

            for (const template of templates) {
                this.activateTemplate(template);
            }
        }
    }

    activatePermissionLessTemplates() {
        document.querySelectorAll(this.options.templateSelector).forEach(template => this.activateTemplate(template));
    }

    /**
     * @param {HTMLTemplateElement} template
     */
    activateTemplate(template) {
        template.parentElement.replaceChild(template.content, template);
    }
}
